import { flex } from '../../../styled-system/patterns';
import { css } from '../../../styled-system/css';
import { extractHighschoolAccountInfo } from '../../features/highschool';
import { DeleteAccount } from '#/features/myPage/components/DeleteAccount/DeleteAccount';
import { LoginAndSecurity } from '#/features/myPage/components/loginAndSecurity/LoginAndSecurity';
import { Organizations } from '#/features/myPage/components/organizations/Organizations';
import { useAccount } from '#/features/myPage/hooks/useAccount';
import { useTitle } from '#/utils/useTitle';
import { useLoginRequired } from '#/utils/auth/useLoginRequired';
import { GenericError } from '#/components/Error';
import { useAuthenticationMethods } from '#/features/myPage/hooks/useMfa';

export function MyPage() {
  useLoginRequired();
  useTitle('マイページ');
  const { data: account, error: accountError } = useAccount();
  const { data: authenticationMethods, error: authenticationMethodError } = useAuthenticationMethods();
  if (accountError || authenticationMethodError) {
    return (
      <div className={flex({ width: '100%', flexDirection: 'column' })}>
        <div
          className={flex({
            paddingTop: '{spacing.20}',
            paddingBottom: '{spacing.40}',
            width: '100%',
            sm: {
              paddingTop: '{spacing.40}',
              paddingBottom: '{spacing.56}',
            },
          })}
        >
          <GenericError />
        </div>
      </div>
    );
  }

  // アカウントロード前には AppLayout の内側は空白になる
  if (!account || authenticationMethods === undefined) {
    return null;
  }

  const highschoolAccountIndo = extractHighschoolAccountInfo(account);

  return (
    <div className={flex({ width: '100%', flexDirection: 'column' })}>
      <div className={css({ padding: '40px 0' })}>
        <LoginAndSecurity
          account={account}
          authenticationMethods={authenticationMethods}
          highschoolAccountInfo={highschoolAccountIndo}
        />
      </div>
      <div className={flex({ flexDirection: 'column', paddingBottom: '56px' })}>
        <Organizations memberships={account.memberships} />
        <DeleteAccount />
      </div>
    </div>
  );
}
